import * as C from '@/consts'
import component from '@/libs/component'

const Books = () => import(/* webpackChunkName: "my" */ './Books')
const Account = () => import(/* webpackChunkName: "my" */ './Account')
const Email = () => import(/* webpackChunkName: "my" */ './Email')
const Password = () => import(/* webpackChunkName: "my" */ './Password')
const Profile = () => import(/* webpackChunkName: "my" */ './Profile')
const License = () => import(/* webpackChunkName: "my" */ './License')
const Payment = () => import(/* webpackChunkName: "my" */ './Payment')
const NewCard = () => import(/* webpackChunkName: "my" */ './NewCard')
const Optins = () => import(/* webpackChunkName: "my" */ './Optins')

export default [
  {
    path: 'my/books',
    name: 'my/books',
    ...component(Books),
    meta: {
      type: C.PAGE_USER
    }
  },
  {
    path: 'my/account',
    name: 'my/account',
    ...component(Account),
    meta: {
      type: C.PAGE_USER
    }
  },
  {
    path: 'my/email',
    name: 'my/email',
    ...component(Email),
    meta: {
      type: C.PAGE_USER
    }
  },
  {
    path: 'my/password',
    name: 'my/password',
    ...component(Password),
    meta: {
      type: C.PAGE_USER
    }
  },
  {
    path: 'my/profile',
    name: 'my/profile',
    ...component(Profile),
    meta: {
      type: C.PAGE_USER
    }
  },
  {
    path: 'my/license',
    name: 'my/license',
    ...component(License),
    meta: {
      type: C.PAGE_USER
    }
  },
  {
    path: 'my/payment',
    name: 'my/payment',
    ...component(Payment),
    meta: {
      type: C.PAGE_USER
    }
  },
  {
    path: 'my/newcard',
    name: 'my/newcard',
    ...component(NewCard),
    meta: {
      type: C.PAGE_USER
    }
  },
  {
    path: 'my/optins',
    name: 'my/optins',
    ...component(Optins),
    meta: {
      type: C.PAGE_USER
    }
  }
]
